import { actions as userAction } from 'Data/ReduxViewModels/User';
import { useState } from 'react';
import Linkify from 'react-linkify';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonGroup, Field, Message, PasswordInput } from '../Core';
import { FieldSet, ListFieldSection } from '../Layout';

const ChangePassword = ({ loginName, onSuccess, wide = false }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showConfirmPassword, setShowConfirmPassword] = useState(true);

  const isChanging = useSelector((state) => state.user.changePassword.isChanging);
  const errorMessage = useSelector((state) => state.user.changePassword.errorMessage);
  const mustChangePasswordMessage = useSelector((state) => state.authentication.mustChangeMessage);
  const authenticatedLoginName = useSelector((state) => state.user.data.LoginName);
  const isUsingEntraAuthentication = useSelector((state) => state.authentication.entra?.isInitialised);
  const dispatch = useDispatch();
  const handleChangePassword = (e) => {
    e.preventDefault();
    return dispatch(
      userAction.putUserPassword({
        loginName: loginName || authenticatedLoginName,
        currentPassword,
        newPassword,
        confirmPassword: showConfirmPassword ? confirmPassword : newPassword,
        onSuccess,
      })
    );
  };
  return (
    <form onSubmit={handleChangePassword} method="post">
      <ListFieldSection single wide={wide}>
        {isUsingEntraAuthentication && (
          <Message info>Change Password is disabled when using Entra authentication</Message>
        )}
        {!!mustChangePasswordMessage && (
          <Message info>
            {mustChangePasswordMessage
              .split(/\r?\n/)
              .filter((s) => s)
              .map((s, i) => (
                <span key={i}>
                  {s}
                  <br />
                </span>
              ))}
          </Message>
        )}
        <div className="LoginPassword">
          <Field
            input={<PasswordInput />}
            label="Current Password"
            name="current-password"
            placeholder="Enter password"
            onChange={(e) => setCurrentPassword(e.target.value)}
            value={currentPassword}
            disabled={isChanging || isUsingEntraAuthentication}
          />
        </div>
        <FieldSet>
          <div className="LoginPassword">
            <Field
              input={<PasswordInput />}
              label="New Password"
              name="new-password"
              placeholder="Enter password"
              onChange={(e) => {
                setNewPassword(e.target.value);
              }}
              value={newPassword}
              disabled={isChanging || isUsingEntraAuthentication}
              onShowPassword={(hidePassword) => {
                setShowConfirmPassword(!hidePassword);
              }}
            />
          </div>

          {showConfirmPassword && (
            <Field
              input={<PasswordInput />}
              label="Confirm New Password"
              name="confirm-password"
              hideVisibilityEye={true}
              placeholder="Enter password"
              onChange={(e) => setConfirmPassword(e.target.value)}
              value={confirmPassword}
              disabled={isChanging || isUsingEntraAuthentication}
            />
          )}
        </FieldSet>
        {errorMessage && (
          <Message error>
            <Linkify properties={{ target: '_blank' }}>
              <ul>
                {errorMessage
                  .split(/\r?\n/)
                  .filter((s) => s)
                  .map((s, i) => (
                    <li key={i}>{s}</li>
                  ))}
              </ul>
            </Linkify>
          </Message>
        )}
        <ButtonGroup>
          <Button submit primary loading={isChanging} disabled={isUsingEntraAuthentication}>
            Change Password
          </Button>
        </ButtonGroup>
      </ListFieldSection>
    </form>
  );
};

export default ChangePassword;
